import React from 'react';
import styled from 'styled-components';
import { TooltipText, Tip, InnerTip } from '@finect/tabular-components/Tooltip';
var LinkWithTooltip = TooltipText.withComponent('span');
var EditorLink = styled.a.withConfig({
  displayName: "Link__EditorLink",
  componentId: "sc-jq29f1-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});
export var Link = function Link(props) {
  var _props$contentState$g = props.contentState.getEntity(props.entityKey).getData(),
    url = _props$contentState$g.url;
  return React.createElement(LinkWithTooltip, null, React.createElement(EditorLink, {
    href: url,
    target: "_blank",
    rel: "nofollow"
  }, props.children, React.createElement(Tip, {
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
    },
    onClick: function onClick() {
      window.open(url);
    }
  }, React.createElement(InnerTip, {
    width: url.length > 24 ? '180px' : null,
    breakWord: url.length > 24
  }, url))));
};